// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const ChartSettingsWidgetListDivider = styled.div`
  background-color: var(--mb-color-border-neutral);
  height: 1px;
  display: block;
  margin-bottom: 1.5rem;
`;
